import { z } from "@core/zod";

export const CategorySchema = z.enum([
  "dairy-eggs",
  "eating-out",
  "fats-oils",
  "fruit-veg",
  "grains-bread",
  "meat-fish",
  "sugar-treats",
]);

export type Category = z.infer<typeof CategorySchema>;
